import React, { Component } from 'react';
import Dialog from 'material-ui/Dialog';
import RaisedButton from 'material-ui/RaisedButton';
import classnames from 'classnames';
import styles from '../styles.scss';

export default class AlertModal extends Component {
  constructor() {
    super();
    this.state = { closing: false };
  }

  close = () => {
    if (this.props.onClose) this.props.onClose();

    // for animation
    this.setState({ closing: true });
    setTimeout(this.props.closeModal, 300);
  };

  handleLinkClick = e => {
    if (e.target.tagName.toLowerCase() === 'a') {
      this.close();
    }
  };

  render() {
    const actions = [
      <RaisedButton
        label={this.props.buttonText || 'OK'}
        primary={true}
        autoFocus={true}
        onClick={this.close}
      />
    ];

    return (
      <div>
        <Dialog
          contentClassName={classnames(
            this.props.className,
            styles.materialModal,
            styles.modalSm
          )}
          style={{ zIndex: 2200 }} // modal has lower zindex than popovers by default
          overlayClassName={styles.modalOverlay}
          title={this.props.title}
          modal={false}
          open={!this.state.closing}
          actions={actions}
          onRequestClose={this.close}
          autoScrollBodyContent={true}
          actionsContainerClassName={styles.modalActions}>
          <span onClick={this.handleLinkClick}>{this.props.text}</span>
        </Dialog>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/modals/alertModal/index.js